export { default as BasicInformation } from "./BasicInformation/BasicInformation";
export { default as BackgroundImage } from "./BackgroundImage/BackgroundImage";
export { default as Departments } from "./Departments/Departments";
export { default as ScholarsAndPeers } from "./ScholarsAndPeers/ScholarsAndPeers";
export { default as InstitutionHeader } from "./InstitutionHeader/InstitutionHeader";
export { default as AcademicInformation } from "./AcademicInformation/AcademicInformation";
export { default as AcademicUnit } from "./AcademicUnit/AcademicUnit";
export { default as UnitInformation } from "./UnitInformation/UnitInformation";
export { default as InternationalCollaborators } from "./InternationalCollaborators";
